/**
 * Submit for Login and Forgot Password
 */
let membersFormSubmit = function () {
	if (membersForm) {
		membersForm.classList.add('sending');
	}
};

let membersForm = document.querySelector('form.oda-members-form');
if (membersForm) {
	membersForm.addEventListener('submit', membersFormSubmit);
}
